import { useSearch } from '@tanstack/react-router'
import { mainnet } from 'viem/chains'

import { UseMarketDetailsResult } from './useMarketDetails'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { MarketInfo, Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { InternalLink } from '@/routing/types'

export interface UseUsdcViaUsdsProxyMarketParams {
  marketInfo: MarketInfo
  reserve: Reserve
  isInSandbox: boolean
}
export function useUsdcViaUsdsProxyMarket({
  marketInfo,
  reserve,
  isInSandbox,
}: UseUsdcViaUsdsProxyMarketParams): UseMarketDetailsResult['usdcViaUsdsProxyMarket'] {
  const { 'usdc-proxy-market': usdcProxyMarket } = useSearch({ from: '/markets/$chainId/$asset' })

  if (import.meta.env.VITE_FEATURE_BORROW_USDC_FROM_USDS !== '1') {
    return undefined
  }

  if (!isInSandbox && marketInfo.chainId !== mainnet.id) {
    return undefined
  }

  const usds = marketInfo.findReserveBySymbol(TokenSymbol('USDS'))
  const usdc = marketInfo.findReserveBySymbol(TokenSymbol('USDC'))
  if (!usds || !usdc) {
    return undefined
  }

  return {
    link: InternalLink({
      to: '/markets/$chainId/$asset',
      params: { chainId: marketInfo.chainId, asset: usds.token.address },
      search: { 'usdc-proxy-market': true },
    }),
    selected: !!usdcProxyMarket,
    showBorrowFromProxyMarketBanner: reserve.token.symbol === TokenSymbol('USDC'),
  }
}
